import formulajs from '@formulajs/formulajs';
import store from '../store'

function fnGetFullName(client){
    let title = '';
    let firstName = '';
    let middleName = '';
    let lastName = '';

    if(client){
        if(client.title){
            title = client?.title + ' ';
        }
        if(client?.firstName){
            firstName = client?.firstName + ' ';
        }
        if(client?.middleName){
            middleName = client?.middleName + ' ';
        }
        if(client?.lastName){
            lastName = client?.lastName;
        }
    }
    return firstName + middleName + lastName;
}
function fnGetFirstName(client){
    let title = '';
    let firstName = '';


    if(client){
        if(client?.title){
            title = client?.title + ' ';
        }
        if(client?.firstName){
            firstName = client?.firstName + ' ';
        }
    }
    return firstName;
}
function fnGetVehicleBasicDetail(values){
    let year = '';
    let make = '';
    let model = '';
    let variant = '';
    let bodyType = '';
    if(values){
        if(values?.year){
            year = values?.year  + ' ';
        }
        if(values?.make){
            make = values?.make + ' ';
        }
        if(values?.model){
            model= values?.model + ' ';
        }
        if(values?.variant){
            variant = values?.variant + ' ';
        }
        if(values?.bodyType){
            bodyType = values?.bodyType;
        }
        return year + make + model + variant + bodyType;
    }
}
function fnGetResidualValueExclusiveGST(values){
    let totalDriveAwayCost = 0;
    let gstOnAsset = 0;
    let rvRate = 0;
    let residualValue = 0;
    if(values){
        if(values?.totalDriveAwayCost){
            totalDriveAwayCost = values?.totalDriveAwayCost;
        }
        if(values?.gstOnAsset){
            gstOnAsset = values?.gstOnAsset;
        }
        if(values?.rvRate){
            rvRate = values?.rvRate;
        }
        residualValue = (Number(totalDriveAwayCost) - Number(gstOnAsset))*Number(rvRate);
    }

    return residualValue.toFixed(2);
}
function fnGetResidualValueInclusiveGST(values){
    let residualValue = 0;
    let residualValueExclusiveGST = 0;
    const GSTRatePercentage100 = fnGSTRatePercentage100(values);
    let getResidualValueExclusiveGST = fnGetResidualValueExclusiveGST(values);

    if(getResidualValueExclusiveGST){
        residualValueExclusiveGST = getResidualValueExclusiveGST;
    }

    residualValue = Number(residualValueExclusiveGST) * Number(GSTRatePercentage100);


    return residualValue.toFixed(2);
}
// FBT Base value
function fnGetFBTBaseValue(values){
    let totalDriveAwayCost = 0;
    let stampDuty = 0;
    let registration = 0;
    let FBTBaseValue = 0;

    totalDriveAwayCost = values?.totalDriveAwayCost || 0
    stampDuty = values?.stampDuty|| 0
    registration = values?.registration || 0
    FBTBaseValue = (Number(totalDriveAwayCost) - Number(stampDuty) - Number(registration));

    return FBTBaseValue.toFixed(2);
}
// Fuel cost
function fnGetFuelCost(values){
    let annualKms = 0;
    let fuelCostPerKM = 0;
    let fuelCostPerAnual = 0;

    if(values){
        if(values.chanageBudgetsYesNo == 'A'){

            if(values?.vehicleCategoryId == 11){

                fuelCostPerAnual = Number(values?.fuelFlatRate);

            }else{
                if(values?.annualKms){
                    annualKms = values?.annualKms;
                }
                if(values.fuelCostPerKM){
                    fuelCostPerKM = values?.fuelCostPerKM;
                }
                fuelCostPerAnual = Number(annualKms)*Number(fuelCostPerKM);
            }
        }else{
            fuelCostPerAnual = Number(values?.fuelBudget);
        }

        return fuelCostPerAnual.toFixed(2);
    }

}

// Tyres cost
function fnGetTyresCostPerAnual(values){
    let annualKms = 0;
    let tyresCostPerKM	= 0;
    let tyresCostPerAnual = 0;

    if(values){
        if(values?.chanageBudgetsYesNo == 'A'){
            if(values?.annualKms){
                annualKms = values?.annualKms;
            }
            if(values?.tyresCostPerKM){
                tyresCostPerKM = values?.tyresCostPerKM;
            }
            tyresCostPerAnual = Number(tyresCostPerKM)*Number(annualKms);
        }else{
            tyresCostPerAnual = Number(values?.tyreBudget);
        }
    }

    return tyresCostPerAnual.toFixed(2);
}

// Servicing cost
function fnGetMaintenanceCostPerAnual(values){
    let serviceCostPerKM = 0;
    let annualKms = 0;
    let maintenanceCostPerAnual = 0;

    if(values){
        if(values?.chanageBudgetsYesNo == 'A'){
            if(values.annualKms){
                annualKms = values?.annualKms;
            }
            if(values?.serviceCostPerKM){
                serviceCostPerKM = values?.serviceCostPerKM;
            }
            maintenanceCostPerAnual = Number(serviceCostPerKM)*Number(annualKms);
        }else{
            maintenanceCostPerAnual = Number(values?.serviceBudget);
        }
    }
    return maintenanceCostPerAnual.toFixed(2);
}

// FV
function fnGetFV(values){
    let totalDriveAwayCost = 0;
    let gstOnAsset = 0;
    let insurance = 0;
    let mcLeaseFee = 0;
    let leaseAdminFee = 0;
    let interest = 0;
    let noFinanceInsurance = 0;
    const BrokerageExGST = fnBrokerageExGST(values);
    const GSTRatePercentage100 = fnGSTRatePercentage100(values);
    let rate = 0;
    let nper = 0;
    let pmt = 0;
    let pv = 0;
    let type = 0;

    if(values){
        if(values?.totalDriveAwayCost){
            totalDriveAwayCost = values?.totalDriveAwayCost;
        }
        if(values?.gstOnAsset){
            gstOnAsset = values?.gstOnAsset;
        }
        if(values?.comprehensiveInsurancePremium){
            insurance = values?.comprehensiveInsurancePremium;
        }
        if(values?.noFinanceInsurance){
            noFinanceInsurance = values?.noFinanceInsurance;
        }
    }
    if(values?.client_lookup_values){
        if(values?.client_lookup_values?.mcLeaseFee){
            mcLeaseFee = values?.client_lookup_values?.mcLeaseFee;
        }
        if(values?.client_lookup_values?.leaseAdminFee){
            leaseAdminFee = values?.client_lookup_values?.leaseAdminFee;
        }
        if(values?.client_lookup_values?.interest){
            interest = values?.client_lookup_values?.interest;
        }
    }
    // =FV(Interest/12,2,0,Asset_Cost-GST_on_Asset+Insurance+Brokerage_ex_GST+((McLease_Fee_ex_GST+Lease_Admin_Fee_ex_GST)*1.1),1)
    // =FV(rate,nper,pmt,[pv],[type])
    // Rate (required argument) – This is the interest rate for each period.
    // Nper (required argument) – The total number of payment periods.
    // Pmt (optional argument) – This specifies the payment per period. If we omit this argument, we need to provide the PV argument.
    // PV (optional argument) – This specifies the present value (PV) of the investment/loan. The PV argument, if omitted, defaults to zero. If we omit the argument, we need to provide the Pmt argument.
    // Type (optional argument) – This defines whether payments are made at start or end of the year. The argument can either be 0 (payment is made at the end of the period) or 1 (the payment is made at the start of the period).

    rate = Number(interest)/12;
    nper = 2;
    pmt = 0;

    /**
     * if noFinanceInsurance == 0 means include insurance
     * if noFinanceInsurance == 1 means not include insurance
     */
    if(noFinanceInsurance == 1){
        pv = Number(totalDriveAwayCost) - Number(gstOnAsset) + Number(BrokerageExGST ) + ((Number(mcLeaseFee) + Number(leaseAdminFee))*1);

    }else{
        pv = Number(totalDriveAwayCost) - Number(gstOnAsset) + Number(insurance) + Number(BrokerageExGST ) + ((Number(mcLeaseFee) + Number(leaseAdminFee))*1);
    }

    type = 1;

    const FV = formulajs.FV(rate, nper, pmt, pv, type);

    return FV.toFixed(2);
}

function fnBrokerageExGST(values){
    // Dealer Brokerage percentage
    let dealerBrokerage = 0;
    // VSA Brokerage percentage
    let brokerageVSA = 0;

    const totalAmountFinanced = fnTotalAmountFinanced(values);

    let output = 0;

    if(values){
        if(values?.dealerBrokerage){
            dealerBrokerage = values?.dealerBrokerage;
        }
        if(values?.client_lookup_values?.brokerageVSA){
            brokerageVSA = values?.client_lookup_values?.brokerageVSA;
        }
    }

    output = Number(totalAmountFinanced) * (Number(dealerBrokerage) + Number(brokerageVSA));

    return output.toFixed(2);
}

//Total Amount Financed
/*
 * Sheet - Finance Lease Payment
 * E42
 * Calculation : Asset_Cost-GST_on_Asset+Lease_Admin_Fee_ex_GST+McLease_Fee_ex_GST
 */
function fnTotalAmountFinanced(values){
    // Asset_Cost - GST_on_Asset + Lease_Admin_Fee_ex_GST + McLease_Fee_ex_GST
    let output = 0;
    let assetCost = 0;
    let gstOnAsset = 0;
    let leaseAdminFeeExGST = 0;
    let mcLeaseFeeExGST = 0;
    let gst = 0;

    if(values){
        if(values?.totalDriveAwayCost){
            assetCost = values?.totalDriveAwayCost;
        }
        if(values?.gstOnAsset){
            gstOnAsset = values?.gstOnAsset;
        }
        if(values?.client_lookup_values?.GST){
            gst = values?.client_lookup_values?.GST;
        }
        if(values?.client_lookup_values?.leaseAdminFeeVSA){
            leaseAdminFeeExGST = Number((values?.client_lookup_values?.leaseAdminFeeVSA));
        }
        if(values?.client_lookup_values?.mcLeaseFee){
            mcLeaseFeeExGST = Number((values?.client_lookup_values?.mcLeaseFee));
        }
    }

    output = Number(assetCost) - Number(gstOnAsset) + Number(leaseAdminFeeExGST) + Number(mcLeaseFeeExGST)

    return output;
}

// Annual Lease (Non VSA Staff)
function fnAnnualLeaseNonVSAStaff(values){
    // PMT(0.1/12, 2*12, 100000, 1000000, 0)
    // rate - The interest rate for the loan.
    // nper - The total number of payments for the loan.
    // pv - The present value, or total value of all loan payments now.
    // fv - [optional] The future value, or a cash balance you want after the last payment is made. Defaults to 0 (zero).
    // type - [optional] When payments are due. 0 = end of period. 1 = beginning of period. Default is 0
    // =PMT(Interest/12,Term-2,B45,Residual_Value,1)*1.1*12

    let interest = 0;
    let term = 0;
    const FV = fnGetFV(values);
    const GSTRatePercentage100 = fnGSTRatePercentage100(values);
    const ResidualValueExclusiveGST = fnGetResidualValueExclusiveGST(values);
    let rate = 0;

    if(values){
        if(values.term){
            term = Number(values.term) - 2;
        }
    }

    if(values?.client_lookup_values){
        if(values?.client_lookup_values?.interest){
            interest = values?.client_lookup_values?.interest;
        }
    }

    rate = Number(interest)/12;

    const PMT = formulajs.PMT(rate, term, FV, ResidualValueExclusiveGST, 1)*Number(GSTRatePercentage100)*12;

    return PMT.toFixed(2);

}
// Lease Payments Inc GST
function fnLeasePaymentsIncGST(values){
    const AnnualLeaseNonVSAStaff = fnAnnualLeaseNonVSAStaff(values);

    const leasePaymentsIncGST = Number(AnnualLeaseNonVSAStaff)/12;

    return leasePaymentsIncGST.toFixed(2);
}
// Finance
function fnGetFinance(values){
    let term = 0;
    let finance = 0;
    const LeasePaymentsIncGST = fnLeasePaymentsIncGST(values);

    if(values){
        if(values?.term){
            term = Number(values?.term);
        }
    }

    finance = (Number(LeasePaymentsIncGST)*(Number(term) - 2))*12/Number(term);

    return finance.toFixed(2);

}
// GST rate
function fnGSTRatePercentage(values){
    let gstRate = 0;
    let gstRatePercentage = 0;

    gstRate = values?.client_lookup_values?.GST || 0

    gstRatePercentage = Number(gstRate);

    return gstRatePercentage.toFixed(2);

}
// GST Rate 1.1
function fnGSTRatePercentage100(values){
    let gstRate100 = 0;
    let gstRate100Percentage = 0;

    gstRate100 = fnGSTRatePercentage(values);

    gstRate100Percentage = (1 + Number(gstRate100));

    return gstRate100Percentage;
}
// Total Annual Budget (Total Running costs)
function fnTotalAnnualBudget(values){
    let insurance = 0;
    let registration = 0;
    let salaryPackagingProviderFee = 0;
    let vehicleBudgetAnnual = 0;
    const finance = fnGetFinance(values);
    const fuel = fnGetFuelCost(values);
    const GetTyresCostPerAnual = fnGetTyresCostPerAnual(values);
    const GetMaintenanceCostPerAnual = fnGetMaintenanceCostPerAnual(values);

    if(values){
        if(values?.comprehensiveInsurancePremium){
            insurance = values?.comprehensiveInsurancePremium;
        }
        if(values?.registration){
            registration = values?.registration;
        }
        if(values?.salaryPackagingProviderFee){
            salaryPackagingProviderFee = values?.salaryPackagingProviderFee;
        }
    }

    vehicleBudgetAnnual = (Number(finance) +
    Number(fuel) +
    Number(GetTyresCostPerAnual) +
    Number(registration) +
    Number(insurance) +
    Number(GetMaintenanceCostPerAnual) +
    Number(salaryPackagingProviderFee));

    return vehicleBudgetAnnual.toFixed(2);
}
function fnFBTCalculationFormula(values){
    let fbtBaseValue = store.getters.getSettingAll?.systemSetting?.fbtBaseValue || 0;

    const totalRunningCost = fnTotalAnnualBudget(values);
    const getFBTBaseValue = fnGetFBTBaseValue(values);
    let fbtBaseEstimate = fnFBTBaseEstimate(values);
    let FBTContributionAfterTax = 0;

    if(values && values?.vehicleCategoryId == 11 && fbtBaseEstimate <= fbtBaseValue){
        if(fbtBaseEstimate <= fbtBaseValue){
            const businessUsePercentage = 100;
            const privateUsePercentage = ((100 - Number(businessUsePercentage))/100);

            FBTContributionAfterTax = Number(totalRunningCost)*Number(privateUsePercentage);

        }
    }else{
        if(values?.businessUsePercentage <= 60){
            FBTContributionAfterTax = Number(getFBTBaseValue)*Number(values?.client_lookup_values?.FBTRate);

        }else{
            const businessUsePercentage = values?.businessUsePercentage;
            const privateUsePercentage = ((100 - Number(businessUsePercentage))/100);

            FBTContributionAfterTax = Number(totalRunningCost)*Number(privateUsePercentage);
        }
    }

    const FBTContributionBeforeTaxDeduction = Number(totalRunningCost) - Number(FBTContributionAfterTax);

        // GST on Before Tax Deduction
        const FBTContributionGSTOnBeforeTaxDeduction = Number(FBTContributionBeforeTaxDeduction)/11;

        // Net Before Tax Deduction Ex GST
        const FBTNetBeforeTaxDeductionExcGST = Number(FBTContributionBeforeTaxDeduction) - Number(FBTContributionGSTOnBeforeTaxDeduction);

        const obj = {
            "FBTContributionAfterTax":FBTContributionAfterTax,
            "FBTContributionBeforeTaxDeduction":FBTContributionBeforeTaxDeduction,
            "FBTContributionGSTOnBeforeTaxDeduction":FBTContributionGSTOnBeforeTaxDeduction,
            "FBTNetBeforeTaxDeductionExcGST":FBTNetBeforeTaxDeductionExcGST,
        }

        return obj;
}



/**
 * 20230307 add
 * Base estimate value
 * @param {*} values
 * @returns
 */
function fnFBTBaseEstimate(values){
    let totalDriveAwayCost = 0;
    let stampDuty = 0;
    let registration = 0;


    if(values && values?.totalDriveAwayCost){
        totalDriveAwayCost = values?.totalDriveAwayCost;
    }
    if(values && values?.stampDuty){
        stampDuty = values?.stampDuty;
    }
    if(values && values?.registration){
        registration = values?.registration;
    }

    return Number(totalDriveAwayCost) - Number(stampDuty) -  Number(registration);

}

//20220903 Add
function fnGetBusinessPercentage(values){
  let fbtBaseValue = store.getters.getSettingAll?.systemSetting?.fbtBaseValue || 0;

    let fbtBaseEstimate = fnFBTBaseEstimate(values);
    let businessUsePercentage = 0;

    if(values && values?.vehicleCategoryId == 11 && fbtBaseEstimate <= fbtBaseValue){
        businessUsePercentage = 100;
    }else{
        businessUsePercentage = values?.businessUsePercentage
    }

    return businessUsePercentage;

}

// Tax Payable
function fnTaxPayableAmount(values, salary){

    // Note: need to make a solution for TaxTable for each client
    let  taxTable = JSON.parse(localStorage.getItem('tax-table'));
    const grossAnnualSalary = salary;
    let value = 0;
    let valueL = 0;
    let valueU = 0;
    let taxRate = 0;
    const arr = [];

    for (let j = 0; j < taxTable.length; j++) {
        let obj={}

        if(taxTable.length == j){
            valueL = Number(taxTable[j].lowerValue);
            valueU = Number(taxTable[j].upperValue);
            taxRate = Number(taxTable[j].TaxRate);

            obj={
            "value":valueU,
            "taxRate":taxRate,
            "taxValue":(Number(grossAnnualSalary) - Number(valueL - 1))*Number(taxRate),
            "condition":"condition1"
            }
            arr.push(obj);
            break;
        }
        if(( grossAnnualSalary <= Number(taxTable[j].upperValue))){
            valueL = Number(taxTable[j].lowerValue);
            valueU = Number(taxTable[j].upperValue);
            taxRate = Number(taxTable[j].TaxRate);

            obj={
               "value":valueU,
               "taxRate":taxRate,
               "taxValue":(Number(grossAnnualSalary) - Number(valueL - 1))*Number(taxRate),
               "condition":"condition2"
            }
            arr.push(obj);
            break;

        }else if(( grossAnnualSalary > Number(taxTable[j]?.upperValue))){
            valueL = Number(taxTable[j]?.lowerValue);
            valueU = Number(taxTable[j]?.upperValue);
            taxRate = Number(taxTable[j]?.TaxRate);

            obj={
            "value":valueU,
            "taxRate":taxRate,
            "taxValue":(Number(valueU) - Number(valueL - 1))*Number(taxRate),
            "condition":"condition3"
            }
            arr.push(obj);

        }else{
            value = Number(grossAnnualSalary) - Number(taxTable[j-1]?.upperValue);
            taxRate = Number(taxTable[j]?.TaxRate);

            obj={
               "value":value,
               "taxRate":taxRate,
               "taxValue":Number(value)*Number(taxRate),
               "condition":"condition4"
            }
            arr.push(obj);
            break;
        }
    }

    let totalTax = 0;
    for (let k = 0; k < arr.length; k++) {
        totalTax += arr[k].taxValue;
    }


    return totalTax;
}
// Net Gross Taxable Salary Without Packaged
function fnNetGrossTaxableSalaryWithoutPackaged(values){
    const grossAnnualSalary = values?.client?.grossAnnualSalary;
    const NetBeforeTaxDeductionExtGST = 0;

    return Number(grossAnnualSalary) - Number(NetBeforeTaxDeductionExtGST);

}
// Net Gross Taxable Salary Packaged
function fnNetGrossTaxableSalaryPackaged(values){
    const FBTCalculationFormula = fnFBTCalculationFormula(values);
    const grossAnnualSalary = values?.client?.grossAnnualSalary;
    const NetBeforeTaxDeductionExtGST = Number(FBTCalculationFormula.FBTNetBeforeTaxDeductionExcGST);

    return Number(grossAnnualSalary) - Number(NetBeforeTaxDeductionExtGST);
}
// Total tax payable (inc Medicare) without Packaged page:Income, Row:19
function fnTotalTaxPayableIncMedicareWithoutPackaged(values){
    const NetGrossTaxableSalary = fnNetGrossTaxableSalaryWithoutPackaged(values);


    const TaxPayableAmount = fnTaxPayableAmount(values, NetGrossTaxableSalary);

    const medicare = Number(NetGrossTaxableSalary)*Number(values?.client_lookup_values?.medicare);

    return Number(TaxPayableAmount) +  Number(medicare);

}
// Total tax payable (inc Medicare) Packaged page:Income, Row:19
function fnTotalTaxPayableIncMedicarePackaged(values){
    let netGrossTaxableSalaryPackaged = fnNetGrossTaxableSalaryPackaged(values);

    const TaxPayableAmount =  fnTaxPayableAmount(values, netGrossTaxableSalaryPackaged);

    const NetGrossTaxableSalary = netGrossTaxableSalaryPackaged;

    const medicare = Number(NetGrossTaxableSalary)*Number(values?.client_lookup_values?.medicare);

    return Number(TaxPayableAmount) + Number(medicare);
}
// Annual Income Tax and Medicare Saving page:Income, Row:31
function fnAnnualIncomeTaxandMedicareSaving(values){

    let totalTaxPayableIncMedicareWithoutPackage = fnTotalTaxPayableIncMedicareWithoutPackaged(values);

    let totalTaxPayableIncMedicarePackaged = fnTotalTaxPayableIncMedicarePackaged(values);

    return Number(totalTaxPayableIncMedicareWithoutPackage - Number(totalTaxPayableIncMedicarePackaged));
}
// Net Salary After Tax without packaged page:Income, Row:21
function fnNetSalaryAfterTaxWithoutPackaged(values){

    let netGrossTaxableSalaryWithoutPackaged = fnNetGrossTaxableSalaryWithoutPackaged(values);

    let totalTaxPayableIncMedicareWithoutPackaged = fnTotalTaxPayableIncMedicareWithoutPackaged(values);

    return Number(netGrossTaxableSalaryWithoutPackaged) - Number(totalTaxPayableIncMedicareWithoutPackaged);
}
// Net Salary After Tax packaged page:Income, Row:21
function fnNetSalaryAfterTaxPackaged(values){

    let netGrossTaxableSalaryPackaged = fnNetGrossTaxableSalaryPackaged(values);

    let totalTaxPayableIncMedicarePackaged = fnTotalTaxPayableIncMedicarePackaged(values);

    return Number( netGrossTaxableSalaryPackaged) - Number(totalTaxPayableIncMedicarePackaged);
}

// Annual Net Salary Packaged page:Income, Row:25
function fnAnnualNetSalaryPackaged(values){
    const FBTCalculationFormula = fnFBTCalculationFormula(values);
    const EmployeeContributionToFBT = FBTCalculationFormula.FBTContributionAfterTax;
    const VehicleRunningCostsAfterTax = 0;

    return (Number(fnNetSalaryAfterTaxPackaged(values)) - Number(EmployeeContributionToFBT) - Number(VehicleRunningCostsAfterTax));
}
// Cost to Take home pay, this is the most important figure  page:Income, Row:30
// Fortnightly Net Cost to Current Salary
function fnFortnightlyNetCostToCurrentSalary(values){
    const AnnualNetSalaryPackaged = fnAnnualNetSalaryPackaged(values);
    const NetSalaryAfterTaxWithoutPackaged = fnNetSalaryAfterTaxWithoutPackaged(values);

    return (Number(AnnualNetSalaryPackaged) - (NetSalaryAfterTaxWithoutPackaged));
}
// Page:Quote Row 57
function fnCustomersWillSave(values){
    const FBTCalculationFormula = fnFBTCalculationFormula(values);
    const AnnualIncomeTaxandMedicareSaving = fnAnnualIncomeTaxandMedicareSaving(values);
    const FBTContributionGSTOnBeforeTaxDeduction = FBTCalculationFormula.FBTContributionGSTOnBeforeTaxDeduction;
    const termsYears = Number(values?.term)/12;
    const customersWillSave = (Number(AnnualIncomeTaxandMedicareSaving) + Number(FBTContributionGSTOnBeforeTaxDeduction))*termsYears;

    return customersWillSave;
}

//Get 2 months deferred of terms
function fnGetTerms2MonthsDeferred(values){
    return Number(values?.term) -2 ;
}

//Get Employer name
function fnGetEmployerName(values){
    let empName ='';

    if(values && values?.client_employment_detail && values?.client_employment_detail?.employerName){
        empName = values?.client_employment_detail?.employerName;
    }
    return empName;
}
//Get pay period in units
function fnGetPayPeriodInUnits(values){
    if(values?.client && values){
        if( values?.client?.payPeriod == 'Weekly' ){
                return 52;
        }else if( values?.client?.payPeriod == 'Fortnightly' ){
                return 26;
        }else if( values?.client?.payPeriod == 'Monthly' ){
                return 12;
        }else{
            return 26;
        }
    }
}
// Get Pay Period
function fnGetPayPeriod(values){
    if(values?.client && values){
        return values?.client?.payPeriod;
    }else{
        return 'Fortnightly';
    }
}

/**
 *
 * @param integer quoteId
 * @param object getQuoteSingle
 * @returns
 */
export function calculation1(quoteType, quoteId, getQuoteSingle){
    let quoteSingle={};
    let quoteCalculatedObj={};
    quoteSingle = getQuoteSingle;
    let quoteSingle_dealer_name ='';

    //Get vehicle details
    let vehicleBasicDetail = fnGetVehicleBasicDetail(quoteSingle);
    let clientFullName = fnGetFullName(quoteSingle.client);
    let clientFirstName = fnGetFirstName(quoteSingle.client);

    //FBT Base Cost of Vehicle
    let FBTBaseValue = fnGetFBTBaseValue(quoteSingle);

    //Residual Value Inc. GST
    let residualValueInclusiveGST  = fnGetResidualValueInclusiveGST(quoteSingle);

    //Lease Cost
    let finance = fnGetFinance(quoteSingle);

    //Fuel budget
    let fuelCost = fnGetFuelCost(quoteSingle);

    //Tyre budget
    let tyresCostPerAnual = fnGetTyresCostPerAnual(quoteSingle);

    //Servicing budget
    let maintenanceCostPerAnual = fnGetMaintenanceCostPerAnual(quoteSingle);

    //Total fortnightly cost inc GST
    let totalAnnualBudget = fnTotalAnnualBudget(quoteSingle)

    //GST Savings
    let GSTSavings = fnFBTCalculationFormula(quoteSingle).FBTContributionGSTOnBeforeTaxDeduction;

    //Income Tax Savings
    let incomeTaxSavings = fnAnnualIncomeTaxandMedicareSaving(quoteSingle);

    //Cost to Fortnightly Take Home Pay
    let costToFortnightlyTakeHomePay = fnFortnightlyNetCostToCurrentSalary(quoteSingle);



    //Fortnightly Salary
    let fortnightlySalary = fnNetGrossTaxableSalaryWithoutPackaged(quoteSingle);

    //fnNetGrossTaxableSalaryWithoutPackaged
    let netGrossTaxableSalaryWithoutPackaged = fnNetGrossTaxableSalaryWithoutPackaged(quoteSingle);

    //Pre Tax Vehicle Deduction
    let preTaxVehicleDeduction = fnFBTCalculationFormula(quoteSingle).FBTNetBeforeTaxDeductionExcGST;

    //TotalTaxPayableIncMedicareWithoutPackaged
    //Tax & Medicare Levy
    let totalTaxPayableIncMedicareWithoutPackaged = fnTotalTaxPayableIncMedicareWithoutPackaged(quoteSingle);

    //fnTotalTaxPayableIncMedicarePackaged
    //Tax & Medicare Levy
    let totalTaxPayableIncMedicarePackaged = fnTotalTaxPayableIncMedicarePackaged(quoteSingle);

    //Post Tax Deduction
    let fBTContributionAfterTax = fnFBTCalculationFormula(quoteSingle).FBTContributionAfterTax;

    //fnCustomersWillSave
    let customersWillSave = fnCustomersWillSave(quoteSingle);

    //Get 2 months deferred of terms
    let getTerms2MonthsDeferred = fnGetTerms2MonthsDeferred(quoteSingle);

    //Get Employer name
    let getEmployerName = fnGetEmployerName(quoteSingle);

    //Get pay period in units
    let payPeriodInUnits = fnGetPayPeriodInUnits(quoteSingle);

    //Get pay period
    let payPeriod = fnGetPayPeriod(quoteSingle);

    // Get Business percentage
    let businessPercentage = fnGetBusinessPercentage(quoteSingle)

    if(quoteSingle && quoteSingle?.dealer && quoteSingle?.dealer?.name !=''){
        quoteSingle_dealer_name = quoteSingle?.dealer?.name;
    }
    quoteCalculatedObj={
        "quoteType":quoteType,
        "quoteId":quoteId,
        "created_at":quoteSingle.created_at,
        "clientFirstName":clientFirstName,
        "clientFullName":clientFullName,
        "employerName":getEmployerName,
        "clientEmail":quoteSingle?.client?.email,
        "grossAnnualSalary":quoteSingle?.client?.grossAnnualSalary,
        "vehicleBasicDetail":vehicleBasicDetail,
        "accessories":quoteSingle?.accessories,
        "annualKms":quoteSingle?.annualKms,
        "totalDriveAwayCost": quoteSingle?.totalDriveAwayCost,
        "gstOnAsset":quoteSingle?.gstOnAsset,
        "FBTBaseValue":FBTBaseValue,
        "leaseTerm": quoteSingle?.term,
        "getTerms2MonthsDeferred":getTerms2MonthsDeferred,
        "residualValueInclusiveGST":residualValueInclusiveGST,
        "vehicleCategoryId":quoteSingle?.vehicleCategoryId,
        "businessUsePercentage":businessPercentage,
        "finance":finance,
        "fuelCost":fuelCost,
        "tyresCostPerAnual":tyresCostPerAnual,
        "maintenanceCostPerAnual":maintenanceCostPerAnual,
        "registration":quoteSingle?.registration,
        "noFinanceInsurance":quoteSingle?.noFinanceInsurance,
        "comprehensiveInsurancePremium":quoteSingle?.comprehensiveInsurancePremium,
        "salaryPackagingProviderFee":quoteSingle?.salaryPackagingProviderFee,
        "totalAnnualBudget":totalAnnualBudget,
        "GSTSavings":GSTSavings,
        "incomeTaxSavings":incomeTaxSavings,
        "costToFortnightlyTakeHomePay":costToFortnightlyTakeHomePay,
        "fortnightlySalary":fortnightlySalary,
        "netGrossTaxableSalaryWithoutPackaged":netGrossTaxableSalaryWithoutPackaged,
        "preTaxVehicleDeduction":preTaxVehicleDeduction,
        "totalTaxPayableIncMedicareWithoutPackaged":totalTaxPayableIncMedicareWithoutPackaged,
        "totalTaxPayableIncMedicarePackaged":totalTaxPayableIncMedicarePackaged,
        "fBTContributionAfterTax":fBTContributionAfterTax,
        "totalNetTakeHomePayWithCurrentPay":(Number(netGrossTaxableSalaryWithoutPackaged) - Number(totalTaxPayableIncMedicareWithoutPackaged)),
        "totalNetTakeHomePayWithAddingThisVehicle":(Number(netGrossTaxableSalaryWithoutPackaged) - Number(preTaxVehicleDeduction) - Number(totalTaxPayableIncMedicarePackaged) -  Number(fBTContributionAfterTax)),
        "customersWillSave":customersWillSave,
        "dealerId":quoteSingle?.dealerId,
        "dealerName":quoteSingle_dealer_name,
        "createdUserName":quoteSingle?.client?.created_user?.firstName + ' ' + quoteSingle?.client?.created_user?.lastName,
        "createdUserMobNumber":quoteSingle?.client?.created_user?.mobilePhone,
        "createdUserEmail":quoteSingle?.client?.created_user?.email,
        "payPeriodInUnits":payPeriodInUnits,
        "payPeriod":payPeriod
    }
    return quoteCalculatedObj;
}


